import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getNews } from "../services/newsService"; // API call function
import DOMPurify from "dompurify";

const RelatedNews = ({ categorySlug,newsSlug }) => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [relatedNews, setRelatedNews] = useState([]);
  const navigate = useNavigate();

  // Get current article slug from URL
  
  useEffect(() => {
    console.log("Category Slug:", categorySlug); // 🔍 Debugging ke liye
    if (categorySlug) {
      fetchRelatedNews(categorySlug, 1, true); // Reset to page 1 when category changes
    }
  }, [categorySlug]);

  const fetchRelatedNews = async (categorySlug, page = 1, reset = false) => {
    if (!categorySlug) return;

    setLoading(true);
    try {
      const requestData = {
        PageNumber: page,
        PageSize: 5, // Load only 5 related news at a time
        Slug: categorySlug,
      };

      const response = await getNews(requestData);

      if (response.success) {

        // Exclude the current article from related news
        const filteredNews = response.newsPagedResult.data.filter(
          (item) => item.slug !== newsSlug
        );

        setRelatedNews([...relatedNews, ...response.newsPagedResult.data]);
        setTotalRecords(response.newsPagedResult.totalRecords);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching related news:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sn-related">
      <h2>People also Read</h2>
      <div className="container">
        {Array.isArray(relatedNews) && relatedNews.length > 0 ? (
          relatedNews.map((item, index) => (
            <div className="row align-items-center mb-4 p-3 border-bottom" key={index}>
              {/* Image Section */}
              <div className="col-md-4 col-12 mb-3 mb-md-0">
                <img
                  src={item.imagePath}
                  className="img-fluid rounded shadow-sm w-100"
                  alt={item.imageAltText}
                  onClick={() => navigate(`/${item.language}/${item.category}/${item.slug}`)}
                  style={{ cursor: "pointer" }}
                />
              </div>

              {/* Text Content */}
              <div className="col-md-8 col-12">
                <h5
                  className="fw-bold mb-2 text-dark post-lineht"
                  onClick={() => navigate(`/${item.language}/${item.category}/${item.slug}`)}
                  style={{ cursor: "pointer" }}
                >
                  {item.title}
                </h5>
                <p
                  className="text-muted mb-0 small post-lineht"
                  onClick={() => navigate(`/${item.language}/${item.category}/${item.slug}`)}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.description.slice(0, 120) + "..."),
                  }}
                  style={{ cursor: "pointer" }}
                ></p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">No News Found</p>
        )}
      </div>

      {/* Load More Button */}
      {Array.isArray(relatedNews) && relatedNews.length < totalRecords && (
        <div className="text-center mt-4">
          <button
            className="btn btn-dark px-5 py-2 w-100 w-md-auto shadow-sm"
            onClick={() => fetchRelatedNews(categorySlug, currentPage + 1)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default RelatedNews;
